{
    "UserTour_Next": "Volgende",
    "UserTour_Cancel": "Laat het me later zien",
    "UserTour_Exit": "Rondleiding uitschakelen",
    "NAME": "UserTour"
}